export const RESOURCE_TYPE_REMOVE = 'RESOURCE_TYPE_REMOVE';